"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./NumberBadge.scss");
var NumberBadgeProps_1 = require("./NumberBadgeProps");
var NumberBadge = function (_a) {
    var accessibilityText = _a.accessibilityText, children = _a.children, className = _a.className, count = _a.count, labelColor = _a.labelColor, testId = _a.testId, urgent = _a.urgent;
    var renderCount = function () {
        if (count > 99) {
            return "99+";
        }
        else {
            return count.toString();
        }
    };
    var badgeClasses = [
        className,
        styles.numberBadge,
        urgent ? "bg-functional-dk-red" : count > 0 ? "bg-cobalt" : "bg-ui-dark-gray",
        "font-medium inline-flex flex-items-center justify-center color-ui-white",
    ];
    var accessibility = children && typeof children === "string" ? children + " " + renderCount() : renderCount();
    var labelClasses = [styles.label, NumberBadgeProps_1.NumberBadgeColors[labelColor], "font-medium mar-r-xxs"];
    return (React.createElement("div", { "data-testid": testId },
        children && React.createElement("span", { className: labelClasses.join(" ") }, children),
        React.createElement("span", { className: badgeClasses.join(" ") },
            " ",
            renderCount(),
            React.createElement("span", { className: "hidden-spoken" }, accessibilityText ? accessibilityText : accessibility))));
};
exports.default = NumberBadge;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NumberBadge/NumberBadge.js
// module id = 1794
// module chunks = 8